import React from 'react';

import { Alert } from '../designSystem';
import { withTranslation } from 'react-i18next';

// stateless component
const CurrentBetaIsFullMessage = ({ t }) => (
  (
    <Alert variant='warning'>
      {t('CurrentBetaIsFullMessage')}
    </Alert>
  )
);

export default withTranslation()(CurrentBetaIsFullMessage);
